import React, { Component } from 'react';

export default class CustomModel extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <React.Fragment>
        <div className={this.props.show ? "modal fade show" : "modal fade"}
          id="model"
          style={this.props.show ? { display: 'block' } : {}}
          onClick={(e) => {
            if (e.target.id == "model")
              this.props.hide()
          }}
        >
          <div className="modal-dialog  modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">{this.props.title}</h3>
                <button type="button" className="close"
                  onClick={(e) => {
                    this.props.hide()
                  }}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.props.body}
              </div>
            </div>
          </div>
        </div>
        <div className={this.props.show ? "modal-backdrop fade show" : ""}>
        </div>
      </React.Fragment>);
  }
}


// WEBPACK FOOTER //
// ./src/modal/CustomModel.js